import menuFilters from './menu-filters'
import menuSearch from './menu-search'


window.addEventListener("load",  function() {
  menuSearch()
  menuFilters()
})